import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import { DatePicker } from '../../../../core/design-system/components/DatePicker';
import { Text } from '../../../../core/design-system/components/Text';
import './common.css';
import './BirthdayStep.css';

const BirthdayStep = ({ onComplete, initialValue }) => {
  const { t, i18n } = useTranslation('onboarding');
  
  // Convertir initialValue en Date si c'est une string, sinon null
  const getInitialDate = () => {
    if (!initialValue) return null;
    const date = new Date(initialValue);
    return isNaN(date.getTime()) ? null : date;
  };

  const [birthday, setBirthday] = useState(getInitialDate());
  const [error, setError] = useState('');
  
  // Vérifier si l'utilisateur a au moins 16 ans
  const isAtLeastSixteen = (birthDate) => {
    if (!birthDate) return false;
    
    const today = new Date();
    const sixteenYearsAgo = new Date(
      today.getFullYear() - 16,
      today.getMonth(),
      today.getDate()
    );
    
    return birthDate <= sixteenYearsAgo;
  };
  
  // Valider et soumettre la date de naissance
  const handleSubmit = () => {
    if (!birthday) {
      setError(t('birthday.required'));
      return;
    }
    
    if (!isAtLeastSixteen(birthday)) {
      setError(t('birthday.age_restriction'));
      return;
    }
    
    // Date valide, passer à l'étape suivante
    onComplete({
      birthday: birthday.toISOString()
    });
  };
  
  return (
    <div className="birthday-step-container">
      <DatePicker
        value={birthday}
        onChange={setBirthday}
        error={error}
        maxDate={new Date()}
        yearRange={100}
        locale={i18n.language} // Utilisation directe de la langue courante
      />
      
      <div className="birthday-info-message">
        <Text variant="caption" color="secondary">
          {t('birthday.description')}
        </Text>
      </div>
      
      <Button 
        onClick={handleSubmit}
        variant="primary"
        className="step-submit-button"
        disabled={!birthday}
      >
        {t('birthday.continue')}
      </Button>
    </div>
  );
};

export default BirthdayStep; 